// Serialização de query string dos endpoints de painel/indicadores.
//
// Estava duplicada em `features/management/api.ts` e `features/dashboard/api.ts`;
// MET-26 acrescenta um terceiro consumidor (o filtro global de /indicadores) com
// 6 dimensões, e três cópias divergindo na regra de omissão gerariam URLs
// diferentes pro MESMO recorte — ou seja, cache keys diferentes no RTK Query.
//
// Regra: chave com `undefined`, `null` ou string vazia NÃO entra na URL. É o que
// faz "sem filtro" serializar igual em toda tela e reaproveitar cache 100% ao
// navegar entre abas.

/** Valor aceito por chave. `number` já entra porque limites/cursores são numéricos. */
export type QsValue = string | number | boolean | undefined | null;

/**
 * Monta `?a=1&b=2` a partir de um objeto de filtros, com `encodeURIComponent` nos
 * valores. Devolve string vazia (não `'?'`) quando nada sobra — concatenar `'?'`
 * sozinho no fim da URL criaria uma segunda cache key para o mesmo dado.
 */
export function qs(params: Record<string, QsValue>): string {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== '',
  );
  if (entries.length === 0) return '';
  return '?' + entries.map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&');
}
